import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";
import { sellerProducts } from "../../actions/products";
//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import { login, auth } from "../../actions/auth";
class SellerProduct extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      products: "",
    };
  }
  async componentDidMount() {
    await this.getProducts();
  }
  getProducts = async () => {
    const user = await this.props.auth;
    var data = JSON.parse(localStorage.getItem("user"));

    if (data) {
      const _res = await this.props.sellerProducts(data._id);

      if (_res) {
        this.setState({
          products: _res,
        });
      }
    }
  };
  render() {
    const { products } = this.state;
    return (
      <Fragment>
        <div className="sellerCoupons-wrapper wrapper-90 max-1600">
          <BreadCrumb title={`My Account`} />
          <div className="container-fluid px-0">
            <div className="row">
              <AccountLeftSidebar />
              <div className="col-md-9">
                <header className="sellerCoupons-header">
                  <h3 className="seller-coupon-title">Seller Products</h3>
                </header>
                <div className="sellerCoupons-table">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col" className="coupons-r-col">
                            <span>Image</span>
                          </th>
                          <th scope="col" className="coupons-r-col">
                            <span>Product Name</span>
                          </th>
                          <th scope="col" className="coupons-r-col">
                            <span>Model</span>
                          </th>
                          <th scope="col" className="coupons-r-col">
                            <span>Price</span>
                          </th>
                          <th scope="col" className="coupons-r-col">
                            <span>Quantity</span>
                          </th>
                          <th scope="col" className="coupons-r-col">
                            <span>Status</span>
                          </th>
                          <th scope="col" className="coupons-r-col">
                            <span>Is Approved</span>
                          </th>
                          <th scope="col" className="coupons-r-col">
                            <span>Action</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {products &&
                          products.map((item, index) => (
                            <tr className="coupon-tbl-row">
                              <td className="coupons-tbl-body">
                                <span>
                                  <img
                                    src={item.images && item.images[0]}
                                    alt="product"
                                    className="seller-product-img"
                                  />
                                </span>
                              </td>
                              <td className="coupons-tbl-body">
                                <span>{item && item.title && item.title}</span>
                              </td>
                              <td className="coupons-tbl-body">
                                <span>{item.model && item.model}</span>
                              </td>
                              <td className="coupons-tbl-body">
                                <span>
                                  ${item.price && Number(item.price).toFixed(2)}
                                </span>
                              </td>
                              <td className="coupons-tbl-body">
                                <span>{item.quantity && item.quantity}</span>
                              </td>
                              <td className="coupons-tbl-body">
                                <span>
                                  {item.status && item.status === true
                                    ? "Enabled"
                                    : "Disabled"}
                                </span>
                              </td>
                              <td className="coupons-tbl-body">
                                <span>
                                  {item.status && item.status === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </td>
                              <td className="coupons-tbl-body">
                                <Link
                                  className="coupuns-dlt-edit"
                                  to={`/product/${item.slug}`}
                                >
                                  <div
                                    title="Edit Coupon"
                                    className="edit-coupon"
                                  >
                                    <span>
                                      <i className="fa fa-eye" />
                                    </span>
                                  </div>
                                </Link>
                              </td>
                              {/* MODAL FOR EDIT COUPON */}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

sellerProducts.prototype = {
  sellerProducts: PropTypes.func.isRequired,
};
auth.prototype = {
  auth: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  _auth: state.auth,
});
export default connect(mapStateToProps, { sellerProducts, auth })(
  SellerProduct
);
